"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.costReports.title': 'Raporty Kosztów',
    'reports.costReports.description': 'Wyświetl koszty użycia AI i analizy',
};
